import { api } from '@/lib/api'

export type CustomizationItem = Record<string, unknown>  // fields: name/type/id; workflow: + config{}

export type CustomizationCategory = {
  key: string
  label: string
  status: 'ok' | 'not_checkable' | 'error'
  items: CustomizationItem[]
  note?: string
}

export type WorkflowMeta = { name: string; issue_types: string[] }

export type CustomizationsReport = {
  project_key: string
  project_id: string | null
  categories: CustomizationCategory[]
  workflows?: WorkflowMeta[]
  warnings: string[]
}

type OpEnvelope = { findings: unknown[]; warnings: string[]; status: string }

export async function runProjectCustomizations(projectKey: string): Promise<CustomizationsReport> {
  const r = await api<OpEnvelope>('/ops/analysis.project_customizations', {
    method: 'POST',
    body: JSON.stringify({ project_key: projectKey, dry_run: false }),
  })
  return r.findings[0] as CustomizationsReport
}
